/* eslint-disable */
var React = require('react');
var SpriteSymbol = require("../node_modules/svg-baker-runtime/browser-symbol.js");
var sprite = require("../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js");

var symbol = new SpriteSymbol({
  "id": "car-coupe-4a717a00--sprite",
  "use": "car-coupe-4a717a00--sprite-usage",
  "viewBox": "0 0 51 19",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 51 19\" id=\"car-coupe-4a717a00--sprite\"><path d=\"M8 6H2.28a1 1 0 00-.97 1.243l1.5 6a1 1 0 00.97.757H8m0-8l7.757-4.848a1 1 0 01.53-.152H20M8 6h12m16.5 0H45a5 5 0 015 5v2a1 1 0 01-1 1h-5m-7.5-8l-9.281-4.885A1 1 0 0026.753 1H20m16.5 5H20m24 8a4 4 0 01-8 0m8 0a4 4 0 00-8 0m0 0H16m0 0a4 4 0 01-8 0m8 0a4 4 0 00-8 0m12-8V1\" stroke=\"#000\" stroke-width=\"2\" /><path d=\"M33 12l4-6H19.5l4 6H33zM1.5 8H4v2H2m48-1h-3l-3-3\" stroke=\"#000\" stroke-width=\".75\" /></symbol>"
});
sprite.add(symbol);

var SvgSpriteIcon = function SvgSpriteIcon(props) {
  return React.createElement(
    'svg',
    Object.assign({
      viewBox: symbol.viewBox
    }, props),
    React.createElement(
      'use',
      {
        xlinkHref: '#' + symbol.id
      }
    )
  );
};

SvgSpriteIcon.viewBox = symbol.viewBox;
SvgSpriteIcon.id = symbol.id;
SvgSpriteIcon.content = symbol.content;
SvgSpriteIcon.url = symbol.url;
SvgSpriteIcon.toString = symbol.toString;

module.exports = SvgSpriteIcon;
module.exports.default = SvgSpriteIcon;
